namespace GeniuzPOS.Purchase {
    export interface PoCNRTVPrintData extends Serenity.ListRequest {
        Para?: Administration.CsParaRow;
        Header?: PoCNRTVRow;
        Supdata?: Supplier.CsSupplierRow;
        Details?: PoCNRTVDtRow[];
        SysDocNo?: string;
        URLpic?: string;
        Paydesc?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
